module.exports = __webpack_public_path__ + "img/portrait-icon.b453f665.svg";